import usePrivateAxios from '@/common/api/usePrivateAxios'
import { BankInstitutionValidationSchema } from '@/features/bankInstitutions/schemas/create.schema'
import { useMutation } from '@tanstack/react-query'
import { AxiosError, AxiosResponse } from 'axios'

interface UseCreateBankInstitutionProps {
  onSuccess?: (response: AxiosResponse) => void
  onError?: (error: AxiosError) => void
}

export const useCreateBankInstitution = ({ onSuccess, onError }: UseCreateBankInstitutionProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['createBankInstitution'],
    mutationFn: async (form: BankInstitutionValidationSchema) => {
      const bank = {
        ...form,
        account_validation_regex: form.account_validation_regex || undefined,
        branch_validation_regex: form.branch_validation_regex || undefined
      }

      return await privateAxios.post('/bank_institutions', bank)
    },
    onSuccess,
    onError,
  })
}
